import { ChatSVGS, getMessageBannerData } from '@zonofi/chats-common';
import { BannerTypeKeys, displayDateTime } from '@zonofi/common';
import React from 'react';

interface BannerProps {
  type: BannerTypeKeys;
  timetoken: string;
}

export const Banner: React.FC<BannerProps> = ({ type, timetoken }) => {
  const {
    displayText = '',
    icon = '',
    color = 'transparent',
  } = getMessageBannerData()[type] || {};
  const Icon = ChatSVGS[icon as keyof typeof ChatSVGS];
  return (
    <div
      className="banner primary-font-regular"
      style={{ backgroundColor: color }}
    >
      <Icon />
      <div className="comms-font-size-regular">{displayText}</div>
      <div className="comms-font-size-small">
        {displayDateTime(timetoken?.toString() || '')}
      </div>
    </div>
  );
};
